<!-- 每日统计报告 -->
<template>
  <div class="statisticsReport">
    <div class="query-bar">
      <div class="query-left">
        <el-form inline>
          <el-form-item label="用户来源:">
            <el-cascader
              filterable
              v-model="source"
              :options="sourceOptions"
              :props="{ checkStrictly: true }"
              :clearable="true"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="选择日期:">
            <el-date-picker
              v-model="filter_date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="query-right">
        <el-button type="primary" @click="handleSureClick">筛选</el-button>
        <ExportProgress ref="downloadDialog"></ExportProgress>
        <ExportExcel
          :config-name="$options.name"
          :excel-data="excelData"
          @emit="handleExportExcel"
        ></ExportExcel>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="date" label="日期"></el-table-column>
        <el-table-column prop="cumulate_num" label="用户量"></el-table-column>
        <el-table-column prop="incre_num" label="新增用户量"></el-table-column>
        <el-table-column prop="active_num" label="活跃用户量"></el-table-column>
        <div slot="empty"><NoData></NoData></div>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getAppListApi as GetArticleAppList, GetUserStatByDay } from '@/api/dataCenter.js';
// import { getAppListApi } from '@/api/setUser';
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';
import { minxinTable } from '../../mixin/table.js';
import { APP_TYPE } from '@/utils/constant';

export default {
  name: 'StatisticsReport',
  components: { NoData, ExportExcel, ExportProgress },
  mixins: [minxinTable],
  props: {},
  data() {
    return {
      source: [], // 发布来源
      sourceOptions: [
        {
          value: 1,
          label: '公众号',
        },
        {
          value: 2,
          label: '小程序',
        },
        {
          value: 3,
          label: 'H5',
        },
        // {
        //   value: 4,
        //   label: '其他',
        // },
        {
          value: 0,
          label: '全部',
        },
      ],
      filter_date: [],
      excelData: [],
    };
  },
  computed: {
    enterpriseId() {
      return this.$store.getters['user/getEnterpriseId'];
    },
  },
  watch: {
    enterpriseId(newVal) {
      if (newVal) {
        this.getSourceList();
      }
    },
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    if (this.enterpriseId) {
      this.getSourceList();
    }
    this.getTableData();
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    /** 获取表格数据
     * @param {Object} val 参数
     * @param {Boolean} isExportExcel 是否导出
     * @return {void}
     */
    async getTableData(val = {}, isExportExcel) {
      this.loading = true;
      if (isExportExcel) {
        this.$refs.downloadDialog.openDialog();
        this.$refs.downloadDialog.startRidiculousProgress(30);
      }
      const query = {
        source: this.source.length >= 1 ? this.source[0] : 0, // 默认全渠道， 1-公众号，2-小程序
        appid: this.source.length >= 2 ? this.source[1] : undefined, // appid
        start_time: undefined, // 开始日期
        end_time: undefined, // 结束日期，默认过去30天
        ...val,
      };
      try {
        if (isExportExcel) {
          const res = await GetUserStatByDay({
            ...query,
            page_index: 1,
            page_size: 1,
          });
          if (res.total_num > 50000) {
            this.$message.warning(`最大支持导出5万条数据，当前数据${res.total_num}条，请重新筛选`);
            this.$refs.downloadDialog.abortProgress();
          } else {
            const res = await GetUserStatByDay({
              ...query,
              page_index: 1,
              page_size: 50000,
            });
            this.excelData = res.data.reduce((arr, item, index) => {
              // 时间
              item.date = this.toFormat(item.date);
              arr[index] = item;
              return arr;
            }, []);
            this.$refs.downloadDialog.finishProgress(500);
          }
          this.loading = false;
          return;
        }
        const res = await GetUserStatByDay({
          ...query,
          page_index: this.currentPage, // 页码
          page_size: this.pageSize, // 默认每页20条
        });
        const resTemp = res.data.reduce((arr, item, index) => {
          // 时间
          item.date = this.toFormat(item.date);
          arr[index] = item;
          return arr;
        }, []);

        this.tableData = resTemp;
        this.total = res.total_num;
      } catch (error) {
        this.$refs.downloadDialog.abortProgress();
        this.$message(error.message);
        this.loading = false;
      }
      this.loading = false;
    },
    // 筛选
    handleSureClick() {
      const { startTime, endTime } = this.toTimeStamp();
      const query = {
        start_time: startTime,
        end_time: endTime,
        page_index: 1,
      };
      this.getTableData(query);
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      const { startTime, endTime } = this.toTimeStamp();
      const query = {
        start_time: startTime,
        end_time: endTime,
      };
      this.getTableData(query);
    },
    // 切换每页显示条目个数
    handleSizeChange(e) {
      this.pageSize = e;
      const { startTime, endTime } = this.toTimeStamp();
      const query = {
        start_time: startTime,
        end_time: endTime,
      };
      this.getTableData(query);
    },
    // 导出表格数据
    handleExportExcel() {
      const { startTime, endTime } = this.toTimeStamp();
      const query = {
        start_time: startTime,
        end_time: endTime,
      };
      this.getTableData(query, true);
    },
    // 获取发布来源
    async getSourceList() {
      try {
        const res = await GetArticleAppList();
        if (res.data && res.data.length) {
          const mapKey = [
            APP_TYPE.officialAccounts,
            APP_TYPE.miniprogram,
            APP_TYPE.H5,
            APP_TYPE.other,
          ];
          mapKey.forEach((key, index) => {
            this.sourceOptions[index].children = res.data
              .filter((item) => item.app_type === key)
              .map((mapItem) => ({
                value: mapItem.appid,
                label: mapItem.app_name,
              }));
          });
        }
        this.sourceOptions.reverse().reverse();
      } catch (err) {
        this.$message.error('查询发布来源失败');
        console.log('error', err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.statisticsReport {
  .query-bar {
    .query-left {
      display: inline-block;
    }
    .query-right {
      float: right;
    }
  }
  .content {
    .pagination {
      float: right;
    }
  }
}
</style>
